import React from "react";
import ReactDOM from "react-dom";
import BenefitsTable from "~/js/sections/general/BenefitsTable";

// const { data = {} } = window.sandals_app.page;
// const { benefitsData } = data;

const benefitsData = {
  tiers: [
    {
      values: [
        {
          text: "No Stays",
          color: "#717376",
        },
        {
          text: "1st Stay",
          color: "#FEBE43",
        },
        {
          text: "2nd Stay",
          color: "#F48374",
        },
        {
          text: "25 Nights\nor $25,000",
          color: "#203C7B",
        },
        {
          text: "45 Nights\nor $40,000",
          color: "#027366",
        },
        {
          text: "100 Nights\nor $90,000",
          color: "#939597",
        },
        {
          text: "250 Nights\nor $220,000",
          color: "#C4BFB4",
        },
        {
          text: "400 Nights\nor $345,000",
          color: "#474749",
        },
      ],
      benefit: "BENEFITS",
      benefitColor: "#000000",
      rowBackgroundColor: "#F1F1F1",
    },
    {
      values: [
        {
          text: "",
          color: "#717376",
        },
        {
          text: "1pt / $1",
          color: "#FEBE43",
        },
        {
          text: "1pt / $1",
          color: "#F48374",
        },
        {
          text: "2pt / $1",
          color: "#203C7B",
        },
        {
          text: "2pt / $1",
          color: "#027366",
        },
        {
          text: "3pt / $1",
          color: "#939597",
        },
        {
          text: "3pt / $1",
          color: "#C4BFB4",
        },
        {
          text: "4pt / $1",
          color: "#474749",
        },
      ],
      benefit: "Earn Reward Points on Resort Stays",
      benefitColor: "#000000",
      rowBackgroundColor: "#FAFAFA",
    },
    {
      values: [
        {
          text: "✓",
          color: "#717376",
        },
        {
          text: "✓",
          color: "#FEBE43",
        },
        {
          text: "✓",
          color: "#F48374",
        },
        {
          text: "✓",
          color: "#203C7B",
        },
        {
          text: "✓",
          color: "#027366",
        },
        {
          text: "✓",
          color: "#939597",
        },
        {
          text: "✓",
          color: "#C4BFB4",
        },
        {
          text: "✓",
          color: "#474749",
        },
      ],
      benefit: "Exclusive First-Look Communications and Offers",
      benefitColor: "#000000",
      rowBackgroundColor: "#F1F1F1",
    },
    {
      values: [
        {
          text: "✓",
          color: "#717376",
        },
        {
          text: "✓",
          color: "#FEBE43",
        },
        {
          text: "✓",
          color: "#F48374",
        },
        {
          text: "✓",
          color: "#203C7B",
        },
        {
          text: "✓",
          color: "#027366",
        },
        {
          text: "✓",
          color: "#939597",
        },
        {
          text: "✓",
          color: "#C4BFB4",
        },
        {
          text: "✓",
          color: "#474749",
        },
      ],
      benefit: "Access to the Official Loyalty Facebook Group",
      benefitColor: "#000000",
      rowBackgroundColor: "#FAFAFA",
    },
    {
      values: [
        {
          text: "",
          color: "#717376",
        },
        {
          text: "5,000",
          color: "#FEBE43",
        },
        {
          text: "250",
          color: "#F48374",
        },
        {
          text: "375",
          color: "#203C7B",
        },
        {
          text: "500",
          color: "#027366",
        },
        {
          text: "750",
          color: "#939597",
        },
        {
          text: "1,000",
          color: "#C4BFB4",
        },
        {
          text: "1,250",
          color: "#474749",
        },
      ],
      benefit: "Reward Bonus Points After Each Stay",
      benefitColor: "#000000",
      rowBackgroundColor: "#F1F1F1",
    },
    {
      values: [
        {
          text: "",
          color: "#717376",
        },
        {
          text: "✓",
          color: "#FEBE43",
        },
        {
          text: "✓",
          color: "#F48374",
        },
        {
          text: "✓",
          color: "#203C7B",
        },
        {
          text: "✓",
          color: "#027366",
        },
        {
          text: "✓",
          color: "#939597",
        },
        {
          text: "✓",
          color: "#C4BFB4",
        },
        {
          text: "✓",
          color: "#474749",
        },
      ],
      benefit:
        "Up to 12% off future stays when booking at the Loyalty & Travel office on resort",
      benefitColor: "#000000",
      rowBackgroundColor: "#FAFAFA",
    },
    {
      values: [
        {
          text: "",
          color: "#717376",
        },
        {
          text: "",
          color: "#FEBE43",
        },
        {
          text: "✓",
          color: "#F48374",
        },
        {
          text: "✓",
          color: "#203C7B",
        },
        {
          text: "✓",
          color: "#027366",
        },
        {
          text: "✓",
          color: "#939597",
        },
        {
          text: "✓",
          color: "#C4BFB4",
        },
        {
          text: "✓",
          color: "#474749",
        },
      ],
      benefit: "Invitation to Member-Only Events on Resort",
      benefitColor: "#000000",
      rowBackgroundColor: "#F1F1F1",
    },
    {
      values: [
        {
          text: "",
          color: "#717376",
        },
        {
          text: "",
          color: "#FEBE43",
        },
        {
          text: "$50",
          color: "#F48374",
        },
        {
          text: "$50",
          color: "#203C7B",
        },
        {
          text: "$150",
          color: "#027366",
        },
        {
          text: "$200",
          color: "#939597",
        },
        {
          text: "$300",
          color: "#C4BFB4",
        },
        {
          text: "$350",
          color: "#474749",
        },
      ],
      benefit: "Red Lane® Spa Credit per couple per stay*",
      benefitColor: "#000000",
      rowBackgroundColor: "#FAFAFA",
    },
    {
      values: [
        {
          text: "",
          color: "#717376",
        },
        {
          text: "",
          color: "#FEBE43",
        },
        {
          text: "✓",
          color: "#F48374",
        },
        {
          text: "✓",
          color: "#203C7B",
        },
        {
          text: "✓",
          color: "#027366",
        },
        {
          text: "✓",
          color: "#939597",
        },
        {
          text: "✓",
          color: "#C4BFB4",
        },
        {
          text: "✓",
          color: "#474749",
        },
      ],
      benefit: "Complimentary photo of your choice from Photo Shop",
      benefitColor: "#000000",
      rowBackgroundColor: "#F1F1F1",
    },
    {
      values: [
        {
          text: "",
          color: "#717376",
        },
        {
          text: "",
          color: "#FEBE43",
        },
        {
          text: "10%",
          color: "#F48374",
        },
        {
          text: "10%",
          color: "#203C7B",
        },
        {
          text: "15%",
          color: "#027366",
        },
        {
          text: "15%",
          color: "#939597",
        },
        {
          text: "20%",
          color: "#C4BFB4",
        },
        {
          text: "20%",
          color: "#474749",
        },
      ],
      benefit: "Exclusive Discount redeemable on resort purchases**",
      benefitColor: "#000000",
      rowBackgroundColor: "#FAFAFA",
    },
    {
      values: [
        {
          text: "",
          color: "#717376",
        },
        {
          text: "",
          color: "#FEBE43",
        },
        {
          text: "",
          color: "#F48374",
        },
        {
          text: "✓",
          color: "#203C7B",
        },
        {
          text: "✓",
          color: "#027366",
        },
        {
          text: "✓",
          color: "#939597",
        },
        {
          text: "✓",
          color: "#C4BFB4",
        },
        {
          text: "✓",
          color: "#474749",
        },
      ],
      benefit: "Special Member Tier Recognition Gift",
      benefitColor: "#000000",
      rowBackgroundColor: "#F1F1F1",
    },
    {
      values: [
        {
          text: "",
          color: "#717376",
        },
        {
          text: "",
          color: "#FEBE43",
        },
        {
          text: "",
          color: "#F48374",
        },
        {
          text: "",
          color: "#203C7B",
        },
        {
          text: "",
          color: "#027366",
        },
        {
          text: "✓",
          color: "#939597",
        },
        {
          text: "✓",
          color: "#C4BFB4",
        },
        {
          text: "✓",
          color: "#474749",
        },
      ],
      benefit: "Invitation to weekly VIP Member Functions",
      benefitColor: "#000000",
      rowBackgroundColor: "#FAFAFA",
    },
    {
      values: [
        {
          text: "",
          color: "#717376",
        },
        {
          text: "",
          color: "#FEBE43",
        },
        {
          text: "",
          color: "#F48374",
        },
        {
          text: "",
          color: "#203C7B",
        },
        {
          text: "",
          color: "#027366",
        },
        {
          text: "✓",
          color: "#939597",
        },
        {
          text: "✓",
          color: "#C4BFB4",
        },
        {
          text: "✓",
          color: "#474749",
        },
      ],
      benefit: "VIP Customer Service Phone Number",
      benefitColor: "#000000",
      rowBackgroundColor: "#F1F1F1",
    },
    {
      values: [
        {
          text: "",
          color: "#717376",
        },
        {
          text: "",
          color: "#FEBE43",
        },
        {
          text: "",
          color: "#F48374",
        },
        {
          text: "",
          color: "#203C7B",
        },
        {
          text: "",
          color: "#027366",
        },
        {
          text: "✓",
          color: "#939597",
        },
        {
          text: "✓",
          color: "#C4BFB4",
        },
        {
          text: "✓",
          color: "#474749",
        },
      ],
      benefit: "Private In-Room Check-in",
      benefitColor: "#000000",
      rowBackgroundColor: "#FAFAFA",
    },
    {
      values: [
        {
          text: "",
          color: "#717376",
        },
        {
          text: "",
          color: "#FEBE43",
        },
        {
          text: "",
          color: "#F48374",
        },
        {
          text: "",
          color: "#203C7B",
        },
        {
          text: "",
          color: "#027366",
        },
        {
          text: "✓",
          color: "#939597",
        },
        {
          text: "✓",
          color: "#C4BFB4",
        },
        {
          text: "✓",
          color: "#474749",
        },
      ],
      benefit: "Fees Waived for Reservation Changes",
      benefitColor: "#000000",
      rowBackgroundColor: "#F1F1F1",
    },
    {
      values: [
        {
          text: "",
          color: "#717376",
        },
        {
          text: "",
          color: "#FEBE43",
        },
        {
          text: "",
          color: "#F48374",
        },
        {
          text: "",
          color: "#203C7B",
        },
        {
          text: "",
          color: "#027366",
        },
        {
          text: "",
          color: "#939597",
        },
        {
          text: "✓",
          color: "#C4BFB4",
        },
        {
          text: "✓",
          color: "#474749",
        },
      ],
      benefit: "Cabana with Service for One Day***",
      benefitColor: "#000000",
      rowBackgroundColor: "#FAFAFA",
    },
    {
      values: [
        {
          text: "",
          color: "#717376",
        },
        {
          text: "",
          color: "#FEBE43",
        },
        {
          text: "",
          color: "#F48374",
        },
        {
          text: "",
          color: "#203C7B",
        },
        {
          text: "",
          color: "#027366",
        },
        {
          text: "",
          color: "#939597",
        },
        {
          text: "",
          color: "#C4BFB4",
        },
        {
          text: "✓",
          color: "#474749",
        },
      ],
      benefit: "Complimentary Private Transfers",
      benefitColor: "#000000",
      rowBackgroundColor: "#F1F1F1",
    },
    {
      values: [
        {
          text: "",
          color: "#717376",
        },
        {
          text: "",
          color: "#FEBE43",
        },
        {
          text: "",
          color: "#F48374",
        },
        {
          text: "",
          color: "#203C7B",
        },
        {
          text: "",
          color: "#027366",
        },
        {
          text: "",
          color: "#939597",
        },
        {
          text: "",
          color: "#C4BFB4",
        },
        {
          text: "✓",
          color: "#474749",
        },
      ],
      benefit: '"Preferred Room Number Once Category is Booked†',
      benefitColor: "#000000",
      rowBackgroundColor: "#FAFAFA",
    },
  ],
  title: {
    color: "#000000",
    label: "MEMBER STATUS",
    backgroundColor: "#FFFFFF",
  },
  headers: [
    {
      color: "#000000",
      label: "MEMBER",
      backgroundColor: "#FFFFFF",
    },
    {
      color: "#FEBE43",
      label: "SELECT",
      backgroundColor: "#FFFFFF",
    },
    {
      color: "#F48374",
      label: "CORAL",
      backgroundColor: "#FFFFFF",
    },
    {
      color: "#203C7B",
      label: "SAPPHIRE",
      backgroundColor: "#FFFFFF",
    },
    {
      color: "#027366",
      label: "EMERALD",
      backgroundColor: "#FFFFFF",
    },
    {
      color: "#939597",
      label: "DIAMOND",
      backgroundColor: "#FFFFFF",
    },
    {
      color: "#C4BFB4",
      label: "PEARL",
      backgroundColor: "#FFFFFF",
    },
    {
      color: "#474749",
      label: "AMBASSADOR",
      backgroundColor: "#FFFFFF",
    },
  ],
  tableHeaderBackground: "#FAFAFA",
};

console.log(benefitsData);

const benefitsTableEl = document.getElementById("js-rewards__benefits");

if (benefitsData && benefitsTableEl) {
  ReactDOM.render(<BenefitsTable data={benefitsData} />, benefitsTableEl);
}
